import Spinner from "react-bootstrap/Spinner";

export default function PageLoader(props) {
  return (
    <section className="content">
      { props.size !== "resizecomponent" ? 
        <div 
          className='d-flex flex-column justify-content-center text-center' 
          style={{height:"70vh", backgroundSize:"cover"}}
        >
          <div>
            <Spinner animation="grow" style={{width: "40px", height: "40px", backgroundColor:"#f5dca6"}}/>
            <Spinner animation="grow" style={{width: "40px", height: "40px", backgroundColor:"#FFBC1C"}} />
            <Spinner animation="grow" style={{width: "40px", height: "40px", backgroundColor:"#a3a2a0"}} />
            <p className="text-dark"><b>{props.loading}</b></p>
          </div>
        </div>
        :
        <div>
          <div 
            className="spinner-border" 
            role="status"
            style={{width: "20px", height: "20px"}}
          >           
          </div>
        </div>
      }
      
    </section>
  );
}